export default __webpack_public_path__ + "static/media/sameer.fefd5c29.jpg";